export const MODAL_ELE_TAG = 'descope-modal';
